// Warn once per unique malformed TLE so interval-driven callers (position
// updates run every 100ms per satellite) don't flood the console.
const warnedTles = new Set<string>();

/**
 * Extract the two element lines from a raw TLE string.
 *
 * Tolerant of the details the API does NOT guarantee: the line separator
 * ("\n" vs "\r\n" — N2YO has switched between them before), surrounding
 * whitespace, and an optional satellite-name header line (3-line TLE).
 *
 * Returns null (and warns once per unique TLE) if both element lines
 * cannot be found. Never split a TLE with a hardcoded separator — use this.
 */
export function parseTleLines(
  tle: string
): [line1: string, line2: string] | null {
  if (!tle) return null;

  const lines = tle
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const line1 = lines.find((line) => line.startsWith("1 "));
  const line2 = lines.find((line) => line.startsWith("2 "));

  if (!line1 || !line2) {
    if (!warnedTles.has(tle)) {
      warnedTles.add(tle);
      console.warn(
        "Could not parse TLE element lines from:",
        JSON.stringify(tle)
      );
    }
    return null;
  }

  return [line1, line2];
}
